export const getIsRequiredField = ({
	requiredFields,
	fieldName,
}: {
	requiredFields?: string[] | null;
	fieldName: string;
}): boolean => {
	return !!requiredFields?.includes(fieldName);
};
